import { z } from 'zod';

// ============================================================================
// Send / notification enums
// ============================================================================

export const NotificationChannelSchema = z.enum(['EMAIL', 'SMS', 'PUSH', 'WHATSAPP']);
export type NotificationChannel = z.infer<typeof NotificationChannelSchema>;

export const NotificationStatusSchema = z.enum([
  'PENDING',
  'QUEUED',
  'SENDING',
  'SENT',
  'DELIVERED',
  'FAILED',
  'BOUNCED',
]);
export type NotificationStatus = z.infer<typeof NotificationStatusSchema>;

// ============================================================================
// Delivery-log enums — superset: includes IN_APP and CANCELLED
// ============================================================================

export const DeliveryLogChannelSchema = z.enum([
  'EMAIL',
  'SMS',
  'PUSH',
  'WHATSAPP',
  'IN_APP',
]);
export type DeliveryLogChannel = z.infer<typeof DeliveryLogChannelSchema>;

export const DeliveryLogStatusSchema = z.enum([
  'PENDING',
  'QUEUED',
  'SENDING',
  'SENT',
  'DELIVERED',
  'FAILED',
  'BOUNCED',
  'CANCELLED',
]);
export type DeliveryLogStatus = z.infer<typeof DeliveryLogStatusSchema>;

// ============================================================================
// Admin-notification enums
// ============================================================================

export const AdminNotificationCategorySchema = z.enum([
  'CAPACITY',
  'PAYMENT',
  'DEVICE',
  'SECURITY',
]);
export type AdminNotificationCategory = z.infer<typeof AdminNotificationCategorySchema>;

export const AdminNotificationSeveritySchema = z.enum(['INFO', 'WARNING', 'CRITICAL']);
export type AdminNotificationSeverity = z.infer<typeof AdminNotificationSeveritySchema>;

export const MinimumSeveritySchema = z.enum(['INFO', 'WARNING', 'CRITICAL']);
export type MinimumSeverity = z.infer<typeof MinimumSeveritySchema>;

export const ReadStatusFilterSchema = z.enum(['all', 'read', 'unread']).default('all');
export type ReadStatusFilter = z.infer<typeof ReadStatusFilterSchema>;
